import { useCallback, useMemo, useRef } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { capitalize } from 'lodash';
import { useDispatch } from 'react-redux';
import { setCheckedGender, useCheckedGenders } from 'reducers/viewsSlice';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

import { useGenders } from '../../Hooks/dataHooks';

const CellRenderer = ({ data: gender }) => (
  <ListItemComp title={capitalize(gender.displayName)} isBoldText={false} withoutBackground padding="16px 24px" />
);

export const Genders = () => {
  const { data: genders } = useGenders();
  const checkedGenders = useCheckedGenders();
  const dispatch = useDispatch();

  const gridRef = useRef();

  const gridStyle = useMemo(() => ({ height: 'calc(100% - 44px)', width: '100%', padding: '8px 8px 0 8px' }), []);

  const columnDefs = useMemo(
    () => [
      {
        field: '',
        flex: 1,
        cellRenderer: CellRenderer,
      },
    ],
    []
  );

  const onSelectionChanged = useCallback(
    (event) => {
      dispatch(setCheckedGender(event.api.getSelectedRows()));
    },
    [dispatch]
  );

  gridRef.current?.api?.forEachNode((node) => {
    const checked = checkedGenders?.find((r) => r.id === node.data.displayName);
    node.setSelected(!!checked);
  });

  return (
    <div style={gridStyle} className="ag-theme-alpine">
      <AgGridReact
        ref={gridRef}
        columnDefs={columnDefs}
        rowData={genders}
        rowHeight={50}
        // rowSelection="multiple"
        onSelectionChanged={onSelectionChanged}
        headerHeight={0}
        checkedRows={checkedGenders}
        // rowClass={'ag-grid-rowhello'}
        onGridReady={() => {
          gridRef?.current?.api?.forEachNode((node) => {
            const checked = checkedGenders?.find((r) => r.id === node.data.displayName);
            node.setSelected(!!checked);
          });
        }}
        rowSelection={{
          enableSelectionWithoutKeys: true,
          mode: 'multiRow',
          enableClickSelection: true,
        }}
      />
    </div>
  );
};
